import type { CtsUrlInterface } from '@/types/types';

export const userModule: CtsUrlInterface = {
  baseUrl: String(import.meta.env.VITE_AUTH_URL),
};
